var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard6D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_6_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_6_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M361.2,373.3c-1.4,0-11.9,1.3-8.2,3.7c1.7,1.1,3.5,1.8,5.1,3.2c0.8,0.7,1.5,1.5,2.1,2.3 c0.5,0.6,0.4,2.1,1.3,2.3c1.3,0.4,2.7-3.4,3.3-4.3c1.2-1.6,2.5-2.7,3.9-4c2.2-1.9,0.2-2.1-1.9-2.5 C365.1,373.4,363.2,373.3,361.2,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M454.9,300c-0.3-5.4-0.5-10.1-1.1-15.5c-0.4-3.7-0.7-12.8-1.4-12.9c-3.3-0.4-3,9.8-3.1,12.5 c-0.1,4.9-0.6,8.8-0.8,13.6c-0.4,8.3,0.1,22.2-4.3,28.3c-2.7,3.8-8,4.8-10.6,9c-2.6,4.1-4.1,10-5.5,14.5 c-2.9,9.4-7.8,15.7-15.9,21.2c-15.7,10.6-32.3,21.3-51.7,22.1c-20-0.7-37.2-11.5-53.4-22.1c-8.4-5.5-13.5-11.7-16.4-21.2 c-1.4-4.6-3-10.5-5.7-14.5c-2.7-4.2-8.6-7.6-11.4-11.4c-4.5-6.2-3.6-17.6-4-25.9c-0.2-4.9-0.7-8.8-0.9-13.6 c-0.1-2.7,0.2-12.9-3.2-12.5c-0.7,0.2-1.1,9.3-1.5,12.9c-0.6,5.4-2,10.5-2.2,16c-0.5,9.5-1.5,17.8-0.8,27.4 c0.7,9.3,3.7,19.4,9.1,27.2c5.8,8.4,11.6,15.4,19.7,21.7c5.1,4,11.1,8.1,16.5,11.7c5.4,3.7,11.7,7,17,10.7 c10.5,7.2,23.8,12.8,36.8,13.4l0,0c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0l0,0c12.6-0.6,25.5-6.1,35.6-13.4c5.2-3.7,10.1-7.8,15.3-11.4 c5.2-3.6,10.6-7.1,15.5-11.1c7.8-6.3,15-13.2,20.6-21.6c5.2-7.8,7.1-16.8,7.8-26C456.5,319.4,455.4,309.5,454.9,300z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M304.7,352.6c1.3,0.2,4.5-1.5,5.6-2c2.3-0.9,4.7-1.6,7.1-2.3c9.1-2.7,17.8-4.1,27.2-3.1 c5.3,0.6,10.4,3.1,15.9,2.8c5.4,0.2,10.6-2.2,15.9-2.8c9.5-1.1,18.1,0.3,27.2,3.1c2.4,0.7,4.8,1.4,7.1,2.3c1.1,0.4,4.3,2.1,5.6,2 c1.4-0.2-2.4-7.9-5.5-9.7c-8.2-4.5-18.5-4.5-26.8-6.6c-2-0.5-4.3-1.3-6-2.3c-2.4-1.4-2.5-1.5-5-0.3c-4.2,2.1-7.9,3.2-12.5,3.4 c-4.7-0.2-8.3-1.4-12.5-3.4c-2.4-1.2-2.5-1.1-5,0.3c-1.8,1-4.1,1.8-6,2.3c-8.3,2-18.6,2-26.8,6.6 C307.1,344.6,303.3,352.4,304.7,352.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard6D);
export default __webpack_public_path__ + "static/media/man_beard_6d.2b85b8dca31037f18a595cb078b5cf48.svg";
export { ForwardRef as ReactComponent };